<script setup lang="ts">
import {ContestObjectiveProgress} from "@/contest/interfaces";
import {computed, ref, watch} from "vue";

const props = defineProps<{
    progress: ContestObjectiveProgress
}>();

const animatedProgress = ref(0);

watch(() => props.progress.percentage, (newVal) => {
    setTimeout(() => {
        animatedProgress.value = newVal;
    }, 300);
}, { immediate: true });

const objectiveComplete = computed(() => props.progress.percentage >= 100);

</script>

<template>
  <div class="flex gap-4 items-center">
    <p class="font-semibold text-lg">
      Objectif
    </p>
    <div class="relative h-7 bg-secondary/20 rounded-lg overflow-hidden flex-1 border-2.5 border-secondary">
      <div
        class="absolute inset-0 h-full bg-secondary transition-all duration-1000 ease-in-out"
        :style="{ width: `${animatedProgress}%` }"
      />
      <div class="relative h-full flex items-center justify-center">
        <div class="flex-1" />
        <span class="text-primary font-semibold px-4 leading-tight relative top-0.5">
          {{ progress.formatted }}
        </span>
        <div class="flex-1 flex justify-end">
          <div v-if="objectiveComplete" class="relative hidden md:block mr-3">
            <span class="font-semibold text-primary relative top-0.5">
              Objectif atteint ! 🥳
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
